import { create, tsx } from '@dojo/framework/core/vdom';
import { Head } from '../../widgets/Head';
import { ConnectStrip } from '../../widgets/ConnectStrip';
import { OSSLinks } from '../../widgets/OSSLinks';
import ContentWrapper from '../../widgets/ContentWrapper';
import ImageSection from '../../widgets/ImageSection';
import LinkButton from '../../widgets/LinkButton';
import Section from '../../widgets/Section';
import Testimonials from '../../widgets/Testimonials';
import OverlapSection from '../../widgets/OverlapSection';
import Page from '../../widgets/Page';
import HeroBackground from '../../widgets/HeroBackground';
import ClippedImageSummary from '../../widgets/ClippedImageSummary';
import Image from '../../widgets/Image';
import Text from '../../widgets/Text';

import * as css from './Work.m.css';

const fmTop = require('../../assets/images/work-mockups/fannie-mae-card-top-right.png');
const fmTopHighRes = require('../../assets/images/work-mockups/fannie-mae-card-top-right@2x.png');
const fmMain = require('../../assets/images/work-mockups/fannie-mae-mockup.png');
const fmMainHighRes = require('../../assets/images/work-mockups/fannie-mae-mockup@2x.png');
const fmBottomLeft = require('../../assets/images/work-mockups/fannie-mae-card-bottom-left.png');
const fmBottomLeftHighRes = require('../../assets/images/work-mockups/fannie-mae-card-bottom-left@2x.png');
const fmBottomRight = require('../../assets/images/work-mockups/fannie-mae-card-bottom-right.png');
const fmBottomRightHighRes = require('../../assets/images/work-mockups/fannie-mae-card-bottom-right@2x.png');

const marriottMain = require('../../assets/images/work-mockups/marriott-mockup.png');
const marriottMainHighRes = require('../../assets/images/work-mockups/marriott-mockup@2x.png');
const marriottBottomLeft = require('../../assets/images/work-mockups/marriot-card-bottom-left.png');
const marriottBottomLeftHighRes = require('../../assets/images/work-mockups/marriot-card-bottom-left@2x.png');
const marriottBottomRight = require('../../assets/images/work-mockups/marriot-card-bottom-right.png');
const marriottBottomRightHighRes = require('../../assets/images/work-mockups/marriot-card-bottom-right@2x.png');

const intuitTop = require('../../assets/images/work-mockups/intuit-card-top-right.png');
const intuitTopHighRes = require('../../assets/images/work-mockups/intuit-card-top-right@2x.png');
const intuitMain = require('../../assets/images/work-mockups/intuit-mockup.png');
const intuitMainHighRes = require('../../assets/images/work-mockups/intuit-mockup@2x.png');
const intuitBottomLeft = require('../../assets/images/work-mockups/intuit-card-bottom-left.png');
const intuitBottomLeftHighRes = require('../../assets/images/work-mockups/intuit-card-bottom-left@2x.png');
const intuitBottomRight = require('../../assets/images/work-mockups/intuit-card-bottom-right.png');
const intuitBottomRightHighRes = require('../../assets/images/work-mockups/intuit-card-bottom-right@2x.png');

const troweMain = require('../../assets/images/work-mockups/t-rowe-mockup.png');
const troweMainHighRes = require('../../assets/images/work-mockups/t-rowe-mockup@2x.png');
const troweBottomLeft = require('../../assets/images/work-mockups/t-rowe-card-bottom-left.png');
const troweBottomLeftHighRes = require('../../assets/images/work-mockups/t-rowe-card-bottom-left@2x.png');
const troweBottomRight = require('../../assets/images/work-mockups/t-rowe-card-bottom-right.png');
const troweBottomRightHighRes = require('../../assets/images/work-mockups/t-rowe-card-bottom-right@2x.png');

const builtTop = require('../../assets/images/work-mockups/built-card-top-right.png');
const builtTopHighRes = require('../../assets/images/work-mockups/built-card-top-right@2x.png');
const builtMain = require('../../assets/images/work-mockups/built-mockup.png');
const builtMainHighRes = require('../../assets/images/work-mockups/built-mockup@2x.png');
const builtBottomLeft = require('../../assets/images/work-mockups/built-card-bottom-left.png');
const builtBottomLeftHighRes = require('../../assets/images/work-mockups/built-card-bottom-left@2x.png');
const builtBottomRight = require('../../assets/images/work-mockups/built-card-bottom-right.png');
const builtBottomRightHighRes = require('../../assets/images/work-mockups/built-card-bottom-right@2x.png');

const centricMain = require('../../assets/images/work-mockups/centric-mockup.png');
const centricMainHighRes = require('../../assets/images/work-mockups/centric-mockup@2x.png');
const centricBottomLeft = require('../../assets/images/work-mockups/centric-card-bottom-left.png');
const centricBottomLeftHighRes = require('../../assets/images/work-mockups/centric-card-bottom-left@2x.png');
const centricBottomRight = require('../../assets/images/work-mockups/centric-card-bottom-right.png');
const centricBottomRightHighRes = require('../../assets/images/work-mockups/centric-card-bottom-right@2x.png');

const skTripWizardTop = require('../../assets/images/work-mockups/sk-trip-wizard-card-top-left.png');
const skTripWizardTopHighRes = require('../../assets/images/work-mockups/sk-trip-wizard-card-top-left@2x.png');
const skTripWizardMain = require('../../assets/images/work-mockups/sk-trip-wizard-mockup.png');
const skTripWizardMainHighRes = require('../../assets/images/work-mockups/sk-trip-wizard-mockup@2x.png');
const skTripWizardBottomLeft = require('../../assets/images/work-mockups/sk-trip-wizard-card-bottom-left.png');
const skTripWizardBottomLeftHighRes = require('../../assets/images/work-mockups/sk-trip-wizard-card-bottom-left@2x.png');
const skTripWizardBottomRight = require('../../assets/images/work-mockups/sk-trip-wizard-card-bottom-right.png');
const skTripWizardBottomRightHighRes = require('../../assets/images/work-mockups/sk-trip-wizard-card-bottom-right@2x.png');

const heroImage = require('../../assets/images/hero-mockups/hero-our-work.png');
const heroImageHighRes = require('../../assets/images/hero-mockups/hero-our-work@2x.png');

const factory = create();

export const Work = factory(function Work() {
	return (
		<Page>
			{{
				head: (
					<Head
						title="Our Work: Case Studies, Open Source Development | SitePen"
						description="View our work, learn how we&#039;ve solved complex problems with enterprise solutions for new and legacy applications, and view our open source projects."
					/>
				),
				hero: {
					background: <HeroBackground background="level1BluePurple" />,
					content: (
						<div classes={[css.hero]}>
							<ClippedImageSummary collapse="hide-medium" contentRatio={0.45}>
								{{
									title: (
										<Text type="hero-primary" responsive="callout-head">
											Our Work
										</Text>
									),
									blurb: (
										<Text type="large-body" responsive="body">
											From proofs-of-concept to fullstack feature development
											to legacy re-engineering, companies rely on our agility
											and expertise in all areas of the software development
											lifecycle. Learn how we help our customers meet their
											development objectives successfully and with confidence.
										</Text>
									),
									images: {
										main: (
											<div classes={[css.heroImage]}>
												<Image
													src={heroImage}
													highResSrc={heroImageHighRes}
													width={894}
													height={554}
												/>
											</div>
										)
									}
								}}
							</ClippedImageSummary>
						</div>
					)
				},
				page: (
					<virtual>
						<Section>
							<ContentWrapper responsive>
								<Testimonials />
							</ContentWrapper>
						</Section>

						<ImageSection shaded="desktop" paddingBottom="none">
							{{
								title: 'Fannie Mae',
								blurb: `Today's engineering teams are faced with the daunting challenge of translating the needs of intricate business processes into software solutions. SitePen's leadership and expertise in user-experience design and front-end application development allowed Fannie Mae to deliver a powerful, integrated tool that will support the needs of their treasury department for years to come.`,
								button: (
									<LinkButton size="smaller" to="casestudyFannie">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={fmMain}
											highResSrc={fmMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									top: (
										<Image
											src={fmTop}
											highResSrc={fmTopHighRes}
											shadow="dark"
											size="lg"
										/>
									),
									bottom: {
										left: (
											<Image
												src={fmBottomLeft}
												highResSrc={fmBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={fmBottomRight}
												highResSrc={fmBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<ImageSection reverse>
							{{
								title: 'Marriott International',
								blurb: `Providing a stable enterprise application, aligning with new technologies, rolling out new features to meet the needs of the business, and giving users a consistent user experience are often contradictory needs for large enterprises. What’s the best way to maintain productivity and usability as an application grows well beyond its original mission?`,
								button: (
									<LinkButton size="smaller" to="casestudyMarriott">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={marriottMain}
											highResSrc={marriottMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									bottom: {
										left: (
											<Image
												src={marriottBottomLeft}
												highResSrc={marriottBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={marriottBottomRight}
												highResSrc={marriottBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<ImageSection shaded="desktop" overlap>
							{{
								title: 'Intuit',
								blurb: `It’s rare that a technology startup successfully creates a product that solves real-world problems and engages customers on their first try. So what happens when that very success creates growing pains for the company?`,
								button: (
									<LinkButton size="smaller" to="casestudyIntuit">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={intuitMain}
											highResSrc={intuitMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									top: (
										<Image
											src={intuitTop}
											highResSrc={intuitTopHighRes}
											shadow="dark"
											size="lg"
										/>
									),
									bottom: {
										left: (
											<Image
												src={intuitBottomLeft}
												highResSrc={intuitBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={intuitBottomRight}
												highResSrc={intuitBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<ImageSection reverse>
							{{
								title: 'T. Rowe Price',
								blurb: `SitePen consulted with Centric Software to build a plan unique to their environment and then start incrementally transitioning their legacy Dojo Toolkit application into TypeScript and a modern framework without interrupting ongoing feature development.`,
								button: (
									<LinkButton size="smaller" to="casestudyTRowePrice">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={troweMain}
											highResSrc={troweMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									bottom: {
										left: (
											<Image
												src={troweBottomLeft}
												highResSrc={troweBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={troweBottomRight}
												highResSrc={troweBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<ImageSection shaded="desktop" overlap>
							{{
								title: 'Built Technologies',
								blurb: `Often when we think we're on the right path with a business application, we realize mistakes were made by not following best practices or using the most recent tools and technologies, and these mistakes affect our project's long-term sustainability. How do you overcome a situation where an app was created with serious technical flaws due to previous missteps?`,
								button: (
									<LinkButton size="smaller" to="casestudyBuilt">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={builtMain}
											highResSrc={builtMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									top: (
										<Image
											src={builtTop}
											highResSrc={builtTopHighRes}
											shadow="dark"
											size="lg"
										/>
									),
									bottom: {
										left: (
											<Image
												src={builtBottomLeft}
												highResSrc={builtBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={builtBottomRight}
												highResSrc={builtBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<ImageSection reverse>
							{{
								title: 'Centric Software',
								blurb: `SitePen consulted with Centric Software to build a plan unique to their environment and then start incrementally transitioning their legacy Dojo Toolkit application into TypeScript and a modern framework without interrupting ongoing feature development.`,
								button: (
									<LinkButton size="smaller" to="casestudyCentric">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={centricMain}
											highResSrc={centricMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									bottom: {
										left: (
											<Image
												src={centricBottomLeft}
												highResSrc={centricBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={centricBottomRight}
												highResSrc={centricBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<ImageSection shaded="desktop" overlap>
							{{
								title: 'Social Knowledge',
								blurb: `Often when we think we're on the right path with a business application, we realize mistakes were made by not following best practices or using the most recent tools and technologies, and these mistakes affect our project's long-term sustainability. How do you overcome a situation where an app was created with serious technical flaws due to previous missteps?`,
								button: (
									<LinkButton size="smaller" to="casestudySocialTripWizard">
										View Case Study
									</LinkButton>
								),
								images: {
									main: (
										<Image
											src={skTripWizardMain}
											highResSrc={skTripWizardMainHighRes}
											shadow="light"
											responsive={{
												medium: { shadow: 'dark' }
											}}
										/>
									),
									top: (
										<Image
											src={skTripWizardTop}
											highResSrc={skTripWizardTopHighRes}
											shadow="dark"
											size="lg"
										/>
									),
									bottom: {
										left: (
											<Image
												src={skTripWizardBottomLeft}
												highResSrc={skTripWizardBottomLeftHighRes}
												shadow="dark"
												size="lg"
											/>
										),
										right: (
											<Image
												src={skTripWizardBottomRight}
												highResSrc={skTripWizardBottomRightHighRes}
												shadow="dark"
												size="lg"
											/>
										)
									}
								}
							}}
						</ImageSection>

						<div classes={[css.trailingDesktop]}>
							<OverlapSection shaded>
								<ContentWrapper>
									<div classes={[css.ossLinks]}>
										<OSSLinks light />
									</div>
								</ContentWrapper>
							</OverlapSection>
							<OverlapSection type="trailing">
								<ConnectStrip trailing />
							</OverlapSection>
						</div>
						<div classes={[css.trailingMobile]}>
							<Section>
								<ContentWrapper>
									<OSSLinks />
								</ContentWrapper>
							</Section>
							<Section shaded type="trailing">
								<ConnectStrip trailing />
							</Section>
						</div>
					</virtual>
				)
			}}
		</Page>
	);
});

export default Work;
